import { useFsfStore } from '@/components/fsf/stores/fsf.store'
import { useFlightStore } from '@/components/fsf/stores/flight.store'

export const useFsfHelpers = () => {
  const fsfStore = useFsfStore()
  const flightStore = useFlightStore()

  const showFooterActionBlock = computed(() => {
    if (fsfStore.isRoundTrip) {
      if (fsfStore.selectedStartDate && fsfStore.selectedEndDate && noData.value) {
        return true
      }

      return !!flightStore.selectedOutboundFlight && !!flightStore.selectedInboundFlight
    }

    if (fsfStore.selectedStartDate && noData.value) {
      return true
    }

    return !!flightStore.selectedOutboundFlight
  })

  const calendarFlights = computed(() =>
    fsfStore.isOutboundFlightType ? flightStore.outboundFlights : flightStore.inboundFlights
  )

  const noData = computed(() => {
    return !calendarFlights.value?.length
  })

  return {
    showFooterActionBlock,
    calendarFlights,
    noData
  }
}
